/**
 * Perex kategorie — ořez na pár řádků s tlačítkem „Zobrazit více“
 *
 * Referenční kategorie (www.abstore.cz/kancelarsky-nabytek/) má perex celý
 * rozbalený. U nás se ořezává, aby produkty nespadly pod ohyb — dlouhý perex
 * se SEO textem jinak zabere celou první obrazovku.
 *
 * Ořez se zapíná AŽ když text skutečně přetéká (a jen tam, kde přetéká o kus,
 * ne o pár pixelů). Krátký perex tak zůstane celý vidět a tlačítko se vůbec
 * nevykreslí. Bez JS zůstává perex kompletní — třídu .is-clamped přidává
 * až tenhle skript, takže obsah není nikdy nedostupný.
 *
 * Vzhled řeší CSS v pages/category.scss (.category-perex.is-clamped,
 * .category-perex-toggle).
 */
(function () {
	var CLAMPED = 'is-clamped';
	var LABEL_MORE = 'Zobrazit více';
	var LABEL_LESS = 'Zobrazit méně';

	// O kolik musí text přetéct, aby se ořez vyplatil. Pod touhle hranicí
	// by tlačítko zabralo víc místa, než kolik ořez ušetří.
	var MIN_OVERFLOW = 40;

	function build(perex) {
		var button = document.createElement('button');
		button.type = 'button';
		button.className = 'category-perex-toggle';
		button.textContent = LABEL_MORE;
		button.setAttribute('aria-expanded', 'false');

		// Perex potřebuje id, aby na něj šlo ukázat z aria-controls.
		if (!perex.id) perex.id = 'category-perex';
		button.setAttribute('aria-controls', perex.id);

		button.addEventListener('click', function () {
			var expanded = !perex.classList.contains(CLAMPED);

			if (expanded) {
				perex.classList.add(CLAMPED);
				button.textContent = LABEL_MORE;
				button.setAttribute('aria-expanded', 'false');
			} else {
				perex.classList.remove(CLAMPED);
				button.textContent = LABEL_LESS;
				button.setAttribute('aria-expanded', 'true');
			}
		});

		perex.parentNode.insertBefore(button, perex.nextSibling);
	}

	function init() {
		var perex = document.querySelector('.category-perex');
		if (!perex) return;
		if (document.querySelector('.category-perex-toggle')) return;

		// Měří se v rozbaleném stavu: scrollHeight je celý text,
		// clientHeight výška po ořezu. Proto se .is-clamped nasadí
		// nejdřív a hned zas sundá, když se ořez nevyplatí.
		perex.classList.add(CLAMPED);

		if (perex.scrollHeight - perex.clientHeight < MIN_OVERFLOW) {
			perex.classList.remove(CLAMPED);
			return;
		}

		build(perex);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();
